import MenuStatusSelect from './status-menu-select';

export default MenuStatusSelect;
